/**
 * Decimalni brojevi za unos i prikaz (numerička tastatura, stepper količine).
 * Prikaz koristi decimalni zarez, bez razdvajanja hiljada (1.5 → "1,5").
 */

/** Zaokruži na `decimals` decimala, polovina od nule. Šum binarnog zapisa se prvo skida na
 *  15 značajnih cifara (0.1 + 0.2 = 0.30000000000000004 → 0.3) — isto kao `roundMoney`. */
export function roundTo(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals);
  const scaled = Math.round(Number((Math.abs(value) * factor).toPrecision(15)));
  return Math.sign(value) * scaled / factor;
}

/** Broj → tekst sa decimalnim zarezom, najviše `decimals` decimala (1.5 → "1,5"). */
export function formatDecimal(value: number, decimals: number): string {
  return String(roundTo(value, decimals)).replace('.', ',');
}

/** Tekst sa zarezom ili tačkom → broj ("12," → 12); prazno ili neispravno → null. */
export function parseDecimal(text: string | null | undefined): number | null {
  if (text == null || text.trim() === '') {
    return null;
  }
  const n = Number(text.replace(',', '.'));
  return Number.isNaN(n) ? null : n;
}
